import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateProposalStageFourCtrl', CreateProposalStageFourCtrl);

    function CreateProposalStageFourCtrl(
        $rootScope,
        $scope,
        createProposalService,
        TradeProposals
    ) {
        var vm = this;
        var TRANSACTION_TYPE = createProposalService.TRANSACTION_TYPE;

        var INDEX_FIRST_TSO = 0;
        var INDEX_SECOND_TSO = 1;
        /**
         * The keys are for bundle cases on whether the tariff has been updated or not.
         *
         * @type {{string: boolean, string: boolean}}
         */
        vm.isReload = {};
        vm.debug = {};

        vm.stageConfig = config;
        vm.submit = submit;
        vm.selectedUnderlyingDeal = selectedUnderlyingDeal;
        vm.updateRegulatedTariff = updateRegulatedTariff;
        vm.getUnderlyingDeals = getUnderlyingDeals;
        vm.isManualCapacitySource = isManualCapacitySource;
        vm.selectedCapacitySource = selectedCapacitySource;
        vm.handleChangedCapacityCategory = handleChangedCapacityCategory;
        vm.isRegulatedTariffUpdateStateValid =
            isRegulatedTariffUpdateStateValid;
        vm.areTwoDealIdsRequiredForBundledContract =
            areTwoDealIdsRequiredForBundledContract;

        vm.CAPACITY_SOURCE = createProposalService.CAPACITY_SOURCE;
        vm.CAPACITY_UNIT = createProposalService.CAPACITY_UNIT;

        vm.errorTarrifNotUpdatedText =
            'Please press the button to update the regulated tariff in order to continue with the creation of the request.';
        vm.validManualCapacityContractIdChars = /^[a-zA-Z0-9 ./#|_-]*$/;

        init();

        $scope.$watch(
            function () {
                return vm.data.details0.capacitySource;
            },
            function () {
                if (!vm.isReload['0']) {
                    $scope.wizard.setFarthestStageIndexToCurrentStage();
                }
                checkRenderUpdateButton('0');
                getUnderlyingDeals('0');
                vm.isReload['0'] = false;

                if (vm.networkPoint.bundled && !vm.isCombiningUnderlyingDeals) {
                    vm.data.details1.capacitySource =
                        vm.data.details0.capacitySource;
                    checkRenderUpdateButton('1');
                    vm.isReload['1'] = false;
                }
            }
        );

        if (vm.networkPoint.bundled) {
            $scope.$watch(
                function () {
                    return vm.data.details1.capacitySource;
                },
                function () {
                    if (!vm.isReload['1']) {
                        $scope.wizard.setFarthestStageIndexToCurrentStage();
                    }
                    checkRenderUpdateButton('1');
                    getUnderlyingDeals('1');
                    vm.isReload['1'] = false;
                }
            );
        }

        function init() {
            vm.ui = {
                capacityUnitsDontMatch: [],
                offerCapacityTooHigh: [],
                updatingRegulatedTariff0: false,
                updatingRegulatedTariff1: false,
                renderUpdateButton0: false,
                renderUpdateButton1: false,
                loadingUnderlyingDeals0: false,
                loadingUnderlyingDeals1: false,
                unknownAuctionSurcharge0: false,
                unknownAuctionSurcharge1: false,
                unknownRegulatedTariff0: false,
                unknownRegulatedTariff1: false,
                errorUpdatingRegulatedTariff0: false,
                errorUpdatingRegulatedTariff1: false
            };
            vm.data = createProposalService.getStageFour();

            vm.networkPoint =
                createProposalService.getStageOne().selectedNetworkPoint;
            vm.config = createProposalService.getStageOne().tsoConfig;

            vm.isSellIntention =
                createProposalService.getStageTwo().intention ===
                createProposalService.INTENTION.SELL;
            vm.isCombiningUnderlyingDeals =
                !!createProposalService.getStageTwo().combineUnderlyingContract;

            vm.offerRuntime =
                createProposalService.getStageThree().offer.runtime;
            vm.offerCapacity =
                createProposalService.getStageThree().offer.capacity;
            vm.isAssignment =
                createProposalService.getStageThree().transactionType ===
                TRANSACTION_TYPE.ASSIGNMENT;

            mapConfigAndOptions();

            initDetailsFor('0');
            initDetailsFor('1');
            initDetails();

            if (angular.isUndefined(vm.data.isTariffUpdated0)) {
                vm.data.isTariffUpdated0 = false;
            }

            if (angular.isUndefined(vm.data.isTariffUpdated1)) {
                vm.data.isTariffUpdated1 = false;
            }

            reinitBalancingCodes();

            vm.data.details0.isRegulatedTariff =
                getRegulatedTariffDefault(INDEX_FIRST_TSO);
            vm.data.details1.isRegulatedTariff =
                getRegulatedTariffDefault(INDEX_SECOND_TSO);
        }

        // If the condition is true, a regulated tariff is required but the UI-Field is disabled
        // so we have to set it to true to be able to continue.
        function getRegulatedTariffDefault(tsoIndex) {
            if (vm.tsoConfig[tsoIndex]) {
                let regulatedTariffRequired =
                    !vm.tsoConfig[tsoIndex].prefillPrice &&
                    !vm.tsoConfig[tsoIndex].capturePriceManually &&
                    vm.tsoConfig[tsoIndex].applyRegulatedTariff;
                let regulatedTariffFieldDisabled =
                    vm.tsoConfig[tsoIndex].creditLimitCheckEnabled &&
                    !vm.tsoConfig[tsoIndex].prefillPrice &&
                    !vm.tsoConfig[tsoIndex].capturePriceManually;
                if (
                    vm.tsoConfig != null &&
                    vm.tsoConfig[tsoIndex] != null &&
                    regulatedTariffRequired &&
                    regulatedTariffFieldDisabled
                ) {
                    return true;
                }
            }

            return false;
        }

        function reinitBalancingCodes() {
            TradeProposals.balancingCodes(
                {
                    networkPointId: vm.networkPoint.id,
                    runtimeStart: vm.offerRuntime.start,
                    runtimeEnd: vm.offerRuntime.end,
                    gasType: vm.networkPoint.gasType0,
                    capacityCategory0: vm.data.details0.capacityCategory,
                    capacityCategory1: vm.data.details1
                        ? vm.data.details1.capacityCategory
                        : undefined
                },
                function (res) {
                    vm.balancingCodeInfo = res;
                    mapConfigAndOptions();
                }
            );
        }

        function mapConfigAndOptions() {
            vm.tsoConfig = [buildTsoConfig(0)];
            vm.options = [buildOptions(0)];

            if (vm.networkPoint.bundled) {
                vm.tsoConfig[1] = buildTsoConfig(1);
                vm.options[1] = buildOptions(1);

                //for bundled contracts only the deal sources offered by both TSOs are available
                if (!vm.isCombiningUnderlyingDeals) {
                    vm.options[0].capacitySources =
                        vm.options[0].capacitySources.filter(
                            (item) =>
                                vm.options[1].capacitySources
                                    .map((item2) => item2.value)
                                    .indexOf(item.value) >= 0
                        );
                }
            }

            if (angular.isUndefined(vm.exchangeRate0)) {
                if (
                    !angular.isUndefined(vm.config.tso0Config) &&
                    !angular.isUndefined(vm.config.tso0Config.exchangeRate)
                ) {
                    updateExchangeRate(vm.config.tso0Config.exchangeRate, 0);
                }
            }

            if (angular.isUndefined(vm.exchangeRate1)) {
                if (
                    !angular.isUndefined(vm.config.tso1Config) &&
                    !angular.isUndefined(vm.config.tso1Config.exchangeRate)
                ) {
                    updateExchangeRate(vm.config.tso1Config.exchangeRate, 1);
                }
            }
        }

        function updateExchangeRate(xchgRate, index) {
            vm['exchangeRate' + index] = {
                value: xchgRate.rate,
                unit: 'EUR/' + xchgRate.isoCode,
                date: moment(xchgRate.validity.start).format('DD.MM.YYYY HH:mm')
            };
        }

        function buildTsoConfig(index) {
            var tsoConfig = vm.config['tso' + index + 'Config'];
            return createProposalService.buildTsoConfig(
                index,
                tsoConfig,
                vm.balancingCodeInfo
            );
        }

        function buildOptions(index) {
            var tsoConfig = vm.config['tso' + index + 'Config'];
            return createProposalService.buildOptions(
                index,
                tsoConfig,
                vm.balancingCodeInfo,
                vm.networkPoint
            );
        }

        function initDetailsFor(index) {
            if (angular.isUndefined(vm.data['details' + index])) {
                vm.data['details' + index] = {};
            }
            var details = vm.data['details' + index];
            if (angular.isUndefined(details.auctionSurcharge)) {
                details.auctionSurcharge = {
                    originalUnit: vm.config.supportedPriceUnits[0]
                };
            }
            if (angular.isUndefined(details.regulatedTariff)) {
                details.regulatedTariff = {
                    originalUnit: vm.config.supportedPriceUnits[0]
                };
            }

            const commodityFeeCharge =
                vm.networkPoint.chargesDto &&
                vm.networkPoint.chargesDto['commodityFee' + index];
            if (commodityFeeCharge && vm.isSellIntention) {
                details.commodityFee = {
                    originalValue: commodityFeeCharge.originalValue,
                    originalUnit: commodityFeeCharge.originalUnit
                };
            }

            // commodity fee is not available for transfer of use https://prisma.atlassian.net/browse/TAG-9967
            if (!vm.isAssignment) {
                delete details.commodityFee;
            }

            if (angular.isUndefined(details.isRegulatedTariff)) {
                details.isRegulatedTariff = false;
            }
            vm.isReload[index] = !!details.capacityContract;
        }

        function initDetails() {
            if (angular.isUndefined(vm.data.tradeProposalComment)) {
                vm.data.tradeProposalComment = '';
            }
        }

        function submit(form: ng.IFormController) {
            var isCapacityAmountValid =
                vm.ui.offerCapacityTooHigh.length <= 0 &&
                vm.ui.capacityUnitsDontMatch.length <= 0;
            if (!form.$valid || !isCapacityAmountValid) {
                $scope.wizard.goToTop();
                return false;
            }

            if (vm.isSellIntention) {
                if (!isRegulatedTariffUpdateStateValid()) {
                    $scope.wizard.goToTop();
                    vm.ui.errorTariffNotUpdated = true;
                    return false;
                }
            }

            if (vm.data.details0.isRegulatedTariff) {
                vm.data.details0.regulatedTariff = undefined;
            }
            if (vm.data.details1.isRegulatedTariff) {
                vm.data.details1.regulatedTariff = undefined;
            }
            if (
                !areTwoDealIdsRequiredForBundledContract() &&
                vm.networkPoint.bundled &&
                !vm.isCombiningUnderlyingDeals &&
                isManualCapacitySource('0') &&
                vm.data.details0.capacityContractId
            ) {
                vm.data.details1.capacityContractId =
                    vm.data.details0.capacityContractId;
            }
            createProposalService.setStageFour(vm.data);
            $scope.wizard.goToNextStage();
        }

        function checkRenderUpdateButton(index) {
            var details = vm.data['details' + index];
            if (
                vm.tsoConfig[index].updateRegulatedTariffAllowed &&
                details.capacitySource !== undefined
            ) {
                vm.ui['renderUpdateButton' + index] =
                    vm.isAssignment &&
                    vm.isSellIntention &&
                    (details.capacitySource ===
                        vm.CAPACITY_SOURCE.PRIMARY_DEAL_ID ||
                        details.capacitySource ===
                            vm.CAPACITY_SOURCE.SECONDARY_TRADE_ID);

                if (
                    vm.ui['renderUpdateButton' + index] &&
                    !vm.isReload[index]
                ) {
                    delete vm.data['details' + index].auctionSurcharge
                        .originalValue;
                    delete vm.data['details' + index].regulatedTariff
                        .originalValue;
                }
            }
        }

        function getUnderlyingDeals(index) {
            if (
                vm.data['details' + index].capacitySource !== 'MANUAL_INPUT' &&
                typeof vm.data['details' + index].capacitySource !== 'undefined'
            ) {
                vm.ui['loadingUnderlyingDeals' + index] = true;
                var nwpId =
                    vm.networkPoint.bundled && vm.isCombiningUnderlyingDeals
                        ? vm.networkPoint['id' + index]
                        : vm.networkPoint.id;

                TradeProposals.underlyingDeals(
                    {
                        networkPointId: nwpId,
                        underlyingDealSource:
                            vm.data['details' + index].capacitySource,
                        runtimeStart: vm.offerRuntime.start,
                        runtimeEnd: vm.offerRuntime.end
                    },
                    function (res) {
                        vm['underlyingDeals' + index] = res;
                        vm.ui['loadingUnderlyingDeals' + index] = false;
                    }
                );
            }
        }

        function isManualCapacitySource(index) {
            return (
                vm.data['details' + index].capacitySource ==
                vm.CAPACITY_SOURCE.MANUAL_INPUT
            );
        }

        function selectedUnderlyingDeal(index) {
            $scope.wizard.setFarthestStageIndexToCurrentStage();
            checkCapacityAmounts(index);
            updateUnderlyingDealId(index);

            if (index === '0') {
                vm.data.isTariffUpdated0 = false;
                updateCharges(0, 0);
                prefillCapacityInformation(0, 0);

                if (vm.networkPoint.bundled && !vm.isCombiningUnderlyingDeals) {
                    vm.data.isTariffUpdated1 = false;
                    vm.data.details1.capacityContract =
                        vm.data.details0.capacityContract;
                    updateCharges(1, 1);
                    prefillCapacityInformation(1, 1);
                }
            } else if (index === '1') {
                vm.data.isTariffUpdated1 = false;
                updateCharges(1, 0);
                prefillCapacityInformation(1, 0);
            }
        }

        function selectedCapacitySource(index) {
            if (index === '0') {
                resetContractInformation(0);
                resetCapacityInformation(0);
                resetCharges(0);

                if (vm.networkPoint.bundled && !vm.isCombiningUnderlyingDeals) {
                    vm.data.details1.capacityContract =
                        vm.data.details0.capacityContract;
                    resetContractInformation(1);
                    resetCapacityInformation(1);
                    resetCharges(1);
                }
            } else if (index === '1') {
                resetContractInformation(1);
                resetCapacityInformation(1);
                resetCharges(1);
            }
        }

        function handleChangedCapacityCategory() {
            reinitBalancingCodes();
        }

        function resetContractInformation(tsoIndex) {
            var details = vm.data['details' + tsoIndex];
            details.capacityContract = undefined;
            details.capacityContractId = undefined;
        }

        function resetCapacityInformation(tsoIndex) {
            var details = vm.data['details' + tsoIndex];
            details.capacityCategory = undefined;
            details.balancingGroup = undefined;
            details.portfolio = undefined;
        }

        function resetCharges(tsoIndex) {
            var details = vm.data['details' + tsoIndex];
            var resetValue = {
                originalValue: { value: null, floatingPointNumber: true },
                originalUnit: vm.config.supportedPriceUnits[0]
            };
            details.auctionSurcharge = angular.copy(resetValue);
            details.regulatedTariff = angular.copy(resetValue);
        }

        function prefillCapacityInformation(tsoIndex, contractIndex) {
            var details = vm.data['details' + tsoIndex];
            details.capacityCategory = copyOrReset(
                details.capacityContract,
                'capacityCategory' + contractIndex,
                undefined
            ).obj;
            if (vm.tsoConfig[tsoIndex].balancingGroupDesired) {
                details.balancingGroup = copyOrReset(
                    details.capacityContract,
                    'balancingGroup' + contractIndex,
                    undefined
                ).obj;
            }
            if (vm.tsoConfig[tsoIndex].portfolioCodeDesired) {
                details.portfolio = copyOrReset(
                    details.capacityContract,
                    'portfolioCode' + contractIndex,
                    undefined
                ).obj;
            }
        }

        function checkCapacityAmounts(index) {
            var details = vm.data['details' + index];

            if (
                !angular.isUndefined(details.capacityContract) &&
                !angular.isUndefined(details.capacityContract.amount)
            ) {
                var errInfo = {
                    offerCapacity: vm.offerCapacity,
                    dealId: details.capacityContract.dealId,
                    networkPointName:
                        details.capacityContract.networkPoint.name,
                    dealCapacity: details.capacityContract.amount
                };

                if (
                    vm.offerCapacity.unit ===
                    details.capacityContract.amount.originalUnit
                ) {
                    vm.ui.capacityUnitsDontMatch.splice(index, 1);

                    var offerCapacity = new Decimal(
                        vm.offerCapacity.value.value
                    );
                    var dealCapacity =
                        details.capacityContract.amount.originalValue.value;
                    if (offerCapacity.greaterThan(dealCapacity)) {
                        vm.ui.offerCapacityTooHigh[index] = errInfo;
                    } else {
                        vm.ui.offerCapacityTooHigh.splice(index, 1);
                    }
                } else {
                    vm.ui.capacityUnitsDontMatch[index] = errInfo;
                }
            }
        }

        function updateUnderlyingDealId(index) {
            var details = vm.data['details' + index];
            if (
                !!vm['underlyingDeals' + index] &&
                !angular.isUndefined(details.capacityContract)
            ) {
                details.capacityContractId = angular.copy(
                    details.capacityContract.dealId
                );
            } else {
                delete details.capacityContract;
                delete details.capacityContractId;
            }
        }

        function updateCharges(tsoIndex, contractIndex) {
            // same conditions as for price panel on ui
            if (vm.isAssignment && vm.isSellIntention) {
                var details = vm.data['details' + tsoIndex];
                var resetTo = {
                    originalValue: { value: '0', floatingPointNumber: true },
                    originalUnit: vm.config.supportedPriceUnits[0]
                };

                var auctionSurchargeCopy = copyOrReset(
                    details.capacityContract,
                    'auctionSurcharge' + contractIndex,
                    resetTo
                );
                details.auctionSurcharge = auctionSurchargeCopy.obj;
                vm.ui['unknownAuctionSurcharge' + tsoIndex] =
                    auctionSurchargeCopy.isReset;

                if (
                    vm.tsoConfig[tsoIndex].prefillPrice &&
                    !vm.tsoConfig[tsoIndex].capturePriceManually
                ) {
                    var regulatedTariffCopy = copyOrReset(
                        details.capacityContract,
                        'regulatedCapacityTariff' + contractIndex,
                        resetTo
                    );
                    details.regulatedTariff = regulatedTariffCopy.obj;
                    vm.ui['unknownRegulatedTariff' + tsoIndex] =
                        regulatedTariffCopy.isReset;
                }
            }
        }

        function copyOrReset(fromObj, from, resetValue) {
            var result = { obj: null, isReset: false };
            if (!!fromObj && !!fromObj[from]) {
                result.obj = angular.copy(fromObj[from]);
            } else {
                result.obj = angular.copy(resetValue);
                result.isReset = true;
            }
            return result;
        }

        function updateRegulatedTariff(index) {
            var details = vm.data['details' + index];

            vm.ui['errorUpdatingRegulatedTariff' + index] = false;
            vm.ui['updatingRegulatedTariff' + index] = true;
            vm.ui.errorTariffNotUpdated = false;

            var resetValue = {
                originalValue: {
                    value: new Decimal(0),
                    floatingPointNumber: true
                },
                originalUnit: vm.config.supportedPriceUnits[0]
            };

            var direction;
            if (vm.networkPoint.bundled) {
                direction = index === 0 ? 'EXIT' : 'ENTRY';
            } else {
                direction = vm.networkPoint.direction;
            }

            TradeProposals.updateUnderlyingTariff(
                {
                    underlyingDeal: details.capacityContract,
                    direction: direction,
                    bundled: vm.networkPoint.bundled,
                    combineUnbundled: vm.isCombiningUnderlyingDeals
                },
                function (res) {
                    if (!angular.isUndefined(res.value)) {
                        details.regulatedTariff = res;
                    } else {
                        vm.ui['errorUpdatingRegulatedTariff' + index] = true;
                        if (!details.regulatedTariff.value) {
                            details.regulatedTariff = angular.copy(resetValue);
                        }
                    }
                    vm.data['isTariffUpdated' + index] = true;
                },
                function () {
                    vm.ui['errorUpdatingRegulatedTariff' + index] = true;
                }
            ).$promise.finally(function () {
                vm.ui['updatingRegulatedTariff' + index] = false;
            });
        }

        function isRegulatedTariffUpdateStateValid() {
            return (
                !vm.isAssignment ||
                ((!vm.tsoConfig[0].updateRegulatedTariffAllowed ||
                    !vm.ui.renderUpdateButton0 ||
                    vm.data.isTariffUpdated0 ||
                    vm.ui.errorUpdatingRegulatedTariff0) &&
                    (!vm.networkPoint.bundled ||
                        !vm.tsoConfig[1].updateRegulatedTariffAllowed ||
                        !vm.ui.renderUpdateButton1 ||
                        vm.data.isTariffUpdated1 ||
                        vm.ui.errorUpdatingRegulatedTariff1))
            );
        }

        function areTwoDealIdsRequiredForBundledContract() {
            return (
                vm.networkPoint.bundled &&
                !vm.isCombiningUnderlyingDeals &&
                isManualCapacitySource('0') &&
                vm.tsoConfig[0].underlyingDealDesired &&
                vm.tsoConfig[1].underlyingDealDesired
            );
        }
    }
})();
